import * as countDownTypes from './types';

export const updateCameraSetting = (data) => ({
  type: countDownTypes.UPDATE_SETTING,
  payload: data,
});

export const resetCameraSetting = () => ({
  type: countDownTypes.RESET_SETTING,
});
